import { render, staticRenderFns } from "./ApprovalLevelsDocument.vue?vue&type=template&id=0cb06c03&"
import script from "./ApprovalLevelsDocument.vue?vue&type=script&lang=js&"
export * from "./ApprovalLevelsDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports